import { AUDIO } from "../core/keys"

export interface AudioAssetSpec {
  key: string
  assetPath: string
  category: "sfx" | "music" | "ui"
}

export const AUDIO_ASSETS: AudioAssetSpec[] = [
  {
    key: AUDIO.BUMPER_HIT_0,
    assetPath: "sfx/bumper/bumper-combo-0.ogg",
    category: "sfx",
  },
  {
    key: AUDIO.BUMPER_HIT_1,
    assetPath: "sfx/bumper/bumper-combo-1.ogg",
    category: "sfx",
  },
  {
    key: AUDIO.BUMPER_HIT_2,
    assetPath: "sfx/bumper/bumper-combo-2.ogg",
    category: "sfx",
  },
  {
    key: AUDIO.BUMPER_HIT_3,
    assetPath: "sfx/bumper/bumper-combo-3.ogg",
    category: "sfx",
  },
  {
    key: AUDIO.MUSIC_01,
    assetPath: "audio/bttf-music-01.ogg",
    category: "music",
  },
  {
    key: AUDIO.MUSIC_BOSS,
    assetPath: "audio/bttf-music-boss.ogg",
    category: "music",
  },
  {
    key: AUDIO.SFX_UI_BEEP,
    assetPath: "sfx/ui/navigation-tone.ogg",
    category: "ui",
  },
  {
    key: AUDIO.SFX_UI_PRESS,
    assetPath: "sfx/ui/fui-button-beep.ogg",
    category: "ui",
  },
  {
    key: AUDIO.SFX_UI_NAVIGATE,
    assetPath: "sfx/ui/navigation-tone.ogg",
    category: "ui",
  },
]
